import { Button, Tooltip } from 'antd';
import { useNavigate } from 'react-router-dom';
import FileCopy from '../../../../assets/icon/file_copy.svg?react';
import { MOOD_API_SERVICE_LINK } from '../../../../constants/apiUrl';
import styles from '../UserProfile.module.scss';

interface ApiKeyInfoProps {
  downloaderApiKey?: string;
  readOnly?: boolean;
  requestApiKey?: () => void;
  credits: number;
  isKeyValid?: boolean;
}

export const ApiKeyInfo = ({
  downloaderApiKey,
  readOnly,
  credits,
  isKeyValid,
  requestApiKey,
}: ApiKeyInfoProps) => {
  const navigate = useNavigate();
  return (
    <div className={styles.additionalActions}>
      {!readOnly && (
        <div>
          <div className={styles.apiKeyInfoInnerContainer}>
            <div className={styles.creditsContainer}>
              Credits: <span>{credits}</span>
            </div>

            <>
              <div className={styles.apiKeyInfoContainer}>
                {downloaderApiKey && (
                  <div>
                    <div>
                      <div>API key:</div>
                      <div className={styles.apiKeySection}>
                        <div className={styles.apiKeyBox}>
                          <div
                            id='UserProfile-CopyApiKey_Input'
                            className={styles.apiKey}
                            onClick={() => {
                              navigator.clipboard.writeText(
                                downloaderApiKey || ''
                              );
                            }}
                          >
                            <div>
                              <Tooltip
                                placement='topLeft'
                                title={downloaderApiKey}
                              >
                                {downloaderApiKey}
                              </Tooltip>
                            </div>
                            <FileCopy />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </>

            <div className={styles.apiKeyInfoContainer}>
              <div>
                <div className={styles.apiKeyButtonContainer}>
                  <div className={styles.buttonOuterContainer}>
                    <Button
                      className={styles.requestApiKeyButton}
                      type='primary'
                      htmlType='button'
                      id='UserProfile-RequestApiKey_Button'
                      onClick={(e) => {
                        e.preventDefault();
                        requestApiKey?.();
                      }}
                    >
                      {downloaderApiKey ? 'Renew API key' : 'Request API key'}
                    </Button>
                  </div>
                  <div id='UserProfile-ApiKeyStatus_Text'>
                    Your API key is{' '}
                    {isKeyValid ? (
                      <b style={{ color: 'green' }}>valid</b>
                    ) : (
                      <b style={{ color: 'red' }}>expired</b>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {!readOnly && (
            <div className={styles.linkContainer}>
              <div className={styles.linkContainer}>
                <p className={styles.linkPrefix}>For details, please visit</p>
                <div
                  className={styles.link}
                  onClick={() => {
                    navigate('/api');
                  }}
                >
                  {MOOD_API_SERVICE_LINK}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
